import type { WebPage } from 'schema-dts';
import getBreadcrumbList from './getBreadcrumbList';

export default function getWebPageWithBreadcrumb(data: App.PageData): WebPage {
  return {
    '@type': 'WebPage',
    '@id': `${data.scope.meta.canonical}#page`,
    url: data.scope.meta.canonical,
    breadcrumb: getBreadcrumbList(data),
  };
}
